export const getFileExtensionLabel  = (extension) => {
  const labels = {
    'image/png': 'PNG',
    'image/jpeg': 'JPEG'
  };

  return (labels[extension] || extension).toUpperCase();
};

export const parseBytes = (bytes, decimals) => {
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (bytes === 0) {
    return {
      amount: 0,
      unit: units[0]
    };
  }

  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return {
    amount: parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)),
    unit: units[i]
  };
};

export const getBase64FromFile = (file) => {
  const reader = new FileReader();

  return new Promise((resolve) => {
    reader.onload = ({ target }) => {
      if (target) {
        resolve(String(target.result));
      }
    };

    reader.readAsDataURL(file);
  });
};

export const downloadFile = (blobParts, filename, contentType) => {
  const a = document.createElement('a');
  let normalizedBlobParts;

  if (!Array.isArray(blobParts)) {
    normalizedBlobParts = [blobParts];
  }

  const blob = new Blob(normalizedBlobParts || blobParts, { type: contentType });

  a.href = window.URL.createObjectURL(blob);
  a.download = filename;
  a.click();
};